import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6aa9475e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa9475e')) {
      api.createRecord('6aa9475e', component.options)
    } else {
      api.reload('6aa9475e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6aa9475e&", function () {
      api.rerender('6aa9475e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_invoices/index.vue"
export default component.exports